import isNotEmpty from "./empty-field";

export default function isCaptchaValid(token) {
  const hasCaptcha = isNotEmpty(token);

  return hasCaptcha;
}
